import { Component, ViewEncapsulation, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'tidy-icon',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./icon.component.scss'],
  template: `
    <div
      *ngIf="name && rippleEffect"
      [desktopAndMobileColor]="true"
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      tidyRipple
    >
      <img
        decoding="async"
        [src]="'assets/svg/' + name + '.svg'"
        (click)="executeAction()"
        [ngStyle]="myStyles"
      >
    </div>

    <img
      decoding="async"
      *ngIf="name && !rippleEffect"
      [src]="'assets/svg/' + name + '.svg'"
      (click)="executeAction()"
      [ngStyle]="myStyles"
    >
    <div *ngIf="iconCount" style="position: absolute; top: -8px; right: -5px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
      {{iconCount}}
    </div>
  `
})

export  class IconComponent implements OnInit {
  @Input() name: string;
  @Input() size: number;
  @Input() color: string;
  @Input() rippleEffect = false;
  @Input() iconCount = 0;
  cooldown = false;

  @Output() action: EventEmitter<any> = new EventEmitter();

  myStyles = {};
  ngOnInit() {
    if (this.size) {
      this.myStyles = {
        'max-height': `${this.size}px`
      };
    }
  }

  executeAction() {
    if (this.cooldown) return;
    this.cooldown = true;
    setTimeout(() => this.cooldown = false, 500);
    this.action.emit();
  }
}
